module.exports = __webpack_public_path__ + "img/loginBgLeft.9ee4e8ab.png";